import {FC} from 'react';

import {CategoryTier} from '@/modules/FinancialHealthScore/scoring';

import {SVG_HEIGHT, SVG_WIDTH, TOTAL_SEGMENTS} from '../../../../constants';
import DialSegment from '../DialSegment';

import styles from './styles.module.scss';

interface DialProps {
  score: number;
  filledCount: number;
  tier: CategoryTier;
}

const Dial: FC<DialProps> = ({score, filledCount, tier}) => {
  return (
    <div className={styles.dial}>
      <svg
        className={styles.dial__svg}
        viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
        aria-hidden="true"
        focusable="false">
        {Array.from({length: TOTAL_SEGMENTS}, (_, i) => (
          <DialSegment key={i} index={i} filled={i < filledCount} tier={tier} />
        ))}
      </svg>
      <div className={styles.dial__readout}>
        <span className={styles.dial__score}>{score}</span>
        <span className={styles.dial__outOf}>out of 100</span>
      </div>
    </div>
  );
};

export default Dial;
